import history from '../history';
export const ExternalUrls = {
    PRICING_PAGE: 'https://www.airmeet.com/hub/pricing',
    TERMS_OF_USE: 'https://www.airmeet.com/hub/terms-of-use/',
    PRIVACY_POLICY: 'https://www.airmeet.com/hub/privacy-policy/',
    PRIVACY_NOTICE: 'https://www.airmeet.com/hub/privacy-notice/',
    HUB_EVENTS: 'https://www.airmeet.com/hub/events/',
    AIRMEET_TWITTER: 'https://twitter.com/airmeet',
    AIRMEET_FACEBOOK: 'https://www.facebook.com/airmeetcom',
    AIRMEET_LINKEDIN: 'https://www.linkedin.com/company/airmeet-com/',
};

export const redirectToHomePage = (baseUrl = null) => {
    // Base url proxy pass should be added at server/nginx level.
    if (process.env.REACT_APP_ENV !== 'production') {
        // Dont redirect to home page for dev and test envs
        history.replace('/signin');
    } else {
        window.location.replace(baseUrl || process.env.REACT_APP_BASE_URL);
    }
};
